import { QueryKeys } from "@/constants/Query";
import { useApiMutation } from "@/hooks/useApiMutation";
import axiosInstance from "@/lib/axios";
import { useQueryClient } from "@tanstack/react-query";
import { useParams } from "@tanstack/react-router";
import type * as fhirTypes from "fhir/r4";

interface DeleteDispositionResponse {
  references: fhirTypes.DocumentReference[];
}

export const useDeleteDisposition = ({
  encounterId,
  carePlanId,
  dispositionId,
}: {
  encounterId: string;
  carePlanId: string;
  dispositionId?: string;
}) => {
  const queryClient = useQueryClient();
  const { patientId } = useParams({ from: "/patient/$patientId" });
  return useApiMutation<DeleteDispositionResponse, void>({
    mutationOptions: {
      mutationKey:
        QueryKeys.Patient.Chart.EpisodesOfCare.CarePlan.Disposition.UPDATE({
          patientId,
          encounterId,
          carePlanId,
        }),
      mutationFn: () => {
        return axiosInstance.delete(
          `/charting/careplan/${carePlanId}/disposition/${dispositionId}`,
        );
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey:
            QueryKeys.Patient.Chart.EpisodesOfCare.CarePlan.Disposition.DEFAULT(
              {
                patientId,
                encounterId,
                carePlanId,
              },
            ),
        });
        queryClient.invalidateQueries({
          queryKey: QueryKeys.Patient.Chart.EpisodesOfCare.CarePlan.SUMMARY({
            patientId,
            encounterId,
          }),
        });
      },
    },
  });
};
